import React from 'react';
import { getLocalizedText } from '@vp-dst/localization-util';

class TooltipPanel extends React.Component{

    render(){

        const {
            shownOnSubmit,
        } = this.props;

            return(
                <div style={{fontSize: 14}}>
                    {shownOnSubmit &&
                    <div style={{fontWeight: 'bold', paddingBottom: 20, fontSize: 16, marginTop:-40, marginRight: 40}}>
                        Your design idea description is very short. Please consider including any of the follwoing information that may be relevant.
                    </div>
                    }
                    
                    <span dangerouslySetInnerHTML={{ __html:getLocalizedText('how-it-works')}}/>
                    
                         
                    <ul className="link-list stylized-list-minimal" style={{marginBottom: '5px'}}>
                        <li>
                            <b>{getLocalizedText('colors')}</b>
                            <ul className="link-list stylized-list">
                                <li>
                                <span dangerouslySetInnerHTML={{ __html:getLocalizedText('colors-tooltip-1')}}/>
                                </li>
                                <li>
                                    {getLocalizedText('colors-tooltip-2')}
                                </li>
                            </ul>
                        </li>
                        <li>
                            <b>{getLocalizedText('text')}</b>
                            <ul className="link-list stylized-list">
                                <li>
                                    <span dangerouslySetInnerHTML={{ __html:getLocalizedText('text-tooltip-1')}}/>
                                </li>
                                <li>
                                    <span dangerouslySetInnerHTML={{ __html:getLocalizedText('text-tooltip-2')}}/>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <b>{getLocalizedText('style')}</b>
                            <ul className="link-list stylized-list">
                                <li>
                                    <span dangerouslySetInnerHTML={{ __html:getLocalizedText('style-tooltip-1')}}/>
                                </li>
                                <li>
                                    {getLocalizedText('style-tooltip-2')}
                                </li>
                            </ul>
                        </li>
                        <li>
                            <b>{getLocalizedText('images')}</b>
                            <ul className="link-list stylized-list">
                                <li>
                                    {getLocalizedText('images-tooltip-1')}
                                </li>
                                <li>
                                    {getLocalizedText('images-tooltip-2')}
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            );
    }
}

export default TooltipPanel;


// WEBPACK FOOTER //
// ./src/components/TooltipPanel.js